import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#89395b";
function SEI({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 19 19" fill={color}><path  d="M9.477 19a9.52 9.52 0 007.101-3.168 2.264 2.264 0 00-2.898-.05l-.164.132a3.823 3.823 0 01-5.239-.43 2.037 2.037 0 00-2.843-.187L3.53 16.922A9.5 9.5 0 009.477 19m3.085-4.602a4.05 4.05 0 015.075.004A9.46 9.46 0 0019 9.5a9.4 9.4 0 00-1.668-5.371 2.26 2.26 0 00-1.969.52l-.156.14a3.82 3.82 0 01-5.254-.187 2.043 2.043 0 00-2.851-.059L4.89 6.621 3.67 5.328l2.216-2.074a3.815 3.815 0 015.336.11 2.04 2.04 0 002.804.097l.157-.14a4.06 4.06 0 011.66-.884A9.5 9.5 0 009.477 0C4.64 0 .648 3.594.035 8.25a3.91 3.91 0 014.477.79 2.124 2.124 0 002.824.19l1.238-.964a4.124 4.124 0 015.242.136l2.41 2.098-1.167 1.336-2.41-2.094a2.345 2.345 0 00-2.981-.082l-1.238.965a3.906 3.906 0 01-5.192-.348 2.124 2.124 0 00-2.968-.062l-.27.25a9.4 9.4 0 002.246 5.219l2.031-1.735a3.816 3.816 0 015.325.356 2.04 2.04 0 002.796.226zm0 0" /></Svg>;
}
SEI.DefaultColor = DefaultColor;
export default SEI;